import React from 'react';
import { useTranslation } from 'react-i18next';
import { PureBiData } from '@wix/da-bi/pkg/events';
import { useRestrictToLoggedIn } from '../../../utils/hooks/useRestrictToLoggedIn';
import ActionBarB18Link from '../../_partials/items/ActionBarB18Link';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import { ReferralType } from '@wix/da-bi/pkg/constants';
export var BuyButton = function (_a) {
    var _b = _a.deviation, deviationId = _b.deviationId, isDownloadable = _b.isDownloadable, isPurchasable = _b.isPurchasable, className = _a.className;
    var t = useTranslation().t;
    var _c = useRestrictToLoggedIn(), isLoggedIn = _c.isLoggedIn, restrictToLoggedIn = _c.restrictToLoggedIn;
    if (!isDownloadable && !isPurchasable) {
        return null;
    }
    return isLoggedIn ? null : (React.createElement(ActionBarItemWrapper, { popoverWrapperClassName: className },
        React.createElement(ActionBarB18Link, { onClick: restrictToLoggedIn(ReferralType.ANON_DOWNLOAD), biData: PureBiData({
                evid: 350,
                ispaiddownload: isPurchasable ? 1 : 0,
                deviationid: deviationId,
            }) }, t('actionbar.download.mustLogIn'))));
};
BuyButton.displayName = 'BuyButton';
export default BuyButton;
//# sourceMappingURL=LoginToDownloadButton.js.map